export interface PosturalTestOption {
  posturalTestId: number;
  posturalOptionId: number;
  examPassedOption: boolean;
  picture?: string;
  pictureAlt: string;
}

export interface PosturalTestDefinition {
  id: number;
  posturalTestName: string;
  posturalTestSlugName: string;
  posturalTestOptions: PosturalTestOption[];
}

export interface PosturalExaminationSelection {
 
  testSlug: string;
  testId: number;
  examId: number;
  patientId: number;
  selectedValue: number;
  passedValue: number;
  prefixNote?: string;
  note?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface PosturalExamination {
  examId: number;
  patientId: number;
  createdAt?: Date;
  updatedAt?: Date;
  date?: Date;
  type: string;
  height?: number;
  weight?: number;
  footSize?: number;
  strongHand?: number;
  doctorId: number;
  medicalStudioId: number;
  additionalNote?: string;
  testSelections?: PosturalExaminationSelection[];
}

export const invalidPosturalExamination: PosturalExamination = {
  examId: -1,
  patientId: -1,
  date: new Date(),
  type: "",
  doctorId: -1,
  medicalStudioId: -1,
};

export interface PosturalTestDefinitionsMap {
  [examType: string]: PosturalTestDefinition[];
}
